<template>
    <div class="pcBottom">
        <div class="grid grid-cols-3 gap-2 mx-2">
            <div class="h-9">
                <router-link to="/computer">
                    <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#FFFFFF" d="M280.4 148.3L96 300.1V464a16 16 0 0 0 16 16l112.1-.3a16 16 0 0 0 15.9-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.6a16 16 0 0 0 16 16.1L464 480a16 16 0 0 0 16-16V300L295.7 148.3a12.2 12.2 0 0 0 -15.3 0zM571.6 251.5L488 182.6V44.1a12 12 0 0 0 -12-12h-56a12 12 0 0 0 -12 12v72.6L318.5 43a48 48 0 0 0 -61 0L4.3 251.5a12 12 0 0 0 -1.6 16.9l25.5 31A12 12 0 0 0 45.2 301l235.2-193.7a12.2 12.2 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0 -1.7-16.9z"/></svg>
                    <div  class="title">{{ $t('footer.homePage') }}</div>
                </router-link>
            </div>
            <div class="h-9">
                <!-- 未登录 -->
                <router-link to="/computer/login" v-show="!login">
                    <div v-html="svg.TreasurePlate"></div>
                    <div  class="title">{{ $t('footer.TreasurePlate') }}</div>
                </router-link>
                <!-- 已经登录 & 代理用户：聚宝盘红包明细 -->
                <router-link to="/computer/treasure" v-show="login && isAgent">
                    <div v-html="svg.TreasurePlate"></div>
                    <div  class="title">{{ $t('footer.TreasurePlate') }}</div>
                </router-link>
                <!-- 已经登录 & 非代理用户：介绍成为代理 -->
                <router-link to="/computer/treasure-plate" v-show="login && !isAgent">
                    <div v-html="svg.TreasurePlate"></div>
                    <div  class="title">{{ $t('footer.TreasurePlate') }}</div>
                </router-link>
            </div>
            <div class="h-9">
                <router-link to="/computer/login" v-show="0==login">
                    <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#FFFFFF" d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"/></svg>
                    <div  class="title">{{ $t('footer.mine') }}</div>
                </router-link>
                <router-link to="/computer/user" v-show="1==login">
                    <svg class="w-[20px] h-[20px] mx-auto mt-[10px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#FFFFFF" d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"/></svg>
                    <div  class="title">{{ $t('footer.mine') }}</div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
// 使用全局变量
import { useGlobalStore } from '@/assets/js/globalStore'
import global from '@/assets/js/global'
// import global from '@/assets/js/global'
// 引入公共函数
import tool from '@/assets/js/tool'
// 需要监听全局变量 global.isLogin 的变化
import { ref, watch, onMounted } from 'vue'
import tag from '@/assets/js/tag'
export default {
    data() {
        return {
            svg: {
                TreasurePlate: tag.TreasurePlate,
            }
        }
    },
    setup() {

        const globalStore = useGlobalStore()
        const login = ref(tool().resolveLoginState())
        const isAgent = ref(tool().resolveAgentState())

        
        const refreshLoginState = () => {
            const normalized = tool().resolveLoginState(globalStore.login)
            login.value = normalized
            global.isLogin = normalized
            localStorage.setItem('isLogin', String(normalized))
            if (globalStore.login !== normalized) {
                globalStore.setLogin(normalized)
            }
        }

        // 刷新页面时 Pinia 会重置，需从 localStorage 恢复代理身份
        const refreshAgentState = () => {
            const normalized = tool().resolveAgentState(globalStore.isAgent)
            isAgent.value = normalized
            if (tool().makeBoolean(globalStore.isAgent) !== normalized) {
                globalStore.setIsAgent(normalized)
            }
        }

        onMounted(() => {
            refreshLoginState()
            refreshAgentState()
        })
        watch(() => globalStore.login, refreshLoginState)
        watch(() => globalStore.isAgent, () => {
            isAgent.value = tool().resolveAgentState(globalStore.isAgent)
        })

        return {
            login,
            isAgent
        }
    }, // End setup(...)
}
</script>

<style>

</style>